import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import {  __CheckSomeAccessToSomeContentType } from '../../../utils/accessControl'
import { useGetQueryState } from '../../../utils/react-query-hooks/general'
import { LoaderCircleV2 } from 'oolib'
import { getQueryParam } from '../../../utils/general'

const RouteSomeAccessToContentType = ({
  children,
  ACTION,

  contentTypes: _contentTypes

}) => {
  const location = useLocation()
  const params = useParams() // use hooks to get params
  const { status, data: userData } = useGetQueryState('userData')

  if (status === 'loading') {
    return <LoaderCircleV2 S />
  }

  // Get content type from URL params directly

  const contentTypes = _contentTypes || params.contentType || params.content_type


  const checkAccess = () => {
    const contentId = getQueryParam(location.search, 'id')
    

    if (!userData?.user) {
      return {
        has: __CheckSomeAccessToSomeContentType({
          user: undefined,
          actions: ACTION || 'UPDATE',
          contentTypes,
        }),
        redirectTo: '/login'
      }
    }

    return {
      has: __CheckSomeAccessToSomeContentType({
        user: userData?.user,
        actions: ACTION || 'UPDATE',
        contentTypes,
      }),
      redirectTo: '/'
    }
  }

  const access = checkAccess()
  

  if (!access.has) {
    return (
      <Navigate 
        to={access.redirectTo} 
        state={{ from: location.pathname + location.search }}
        replace 
      />
    )
  }

  return children
}

export default RouteSomeAccessToContentType